import cn from 'classnames';
import { FC, useEffect, useMemo, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button } from 'src/components/common/Button';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { icons } from 'src/configs/icons';
import { useBannerActions } from 'src/hooks/useBannerActions';
import { useGameAction } from 'src/hooks/useGameAction';
import { CmsCta } from 'src/types/cms/cmsFieldTypes';
import { RootState } from 'src/types/store-types';
import { TEMPLATE_BANNNER_RADIUS, TEMPLATE_RADIUS } from 'src/utils/constants';
import '../styles.scss';

type Props = {
  cols: number;
  rows: number;
  carouselItemData: any;
};
const CarouselSlideItem: FC<Props> = ({ carouselItemData, cols }) => {
  const { t } = useTranslation();

  const { providerAction, loginAction, registrAction, promotionAction, categoryAction, externalUrlAction } =
    useBannerActions();
  const { handleActionGame } = useGameAction();

  const { selectedCategory } = useSelector((state: RootState) => state.app);
  const { user, kycStatus, totalActivityLimitValue, totalBetLimitValue, totalLossLimitValue, totalDepositValue } =
    useSelector((state: RootState) => state.user);
  const { categoriesData, generalConfigs } = useSelector((state: RootState) => state.configs);
  const { tags } = useSelector((state: RootState) => state.games);

  const [tagList, setTagList] = useState<any[]>([]);

  const ctaAction = (cta: CmsCta): void => {
    console.log('cta', cta);
    switch (cta?.variant) {
      case 'goToRegister':
        registrAction();
        break;
      case 'goToLogin':
        loginAction();
        break;
      case 'goToPromotion':
        promotionAction(cta?.param);
        break;
      case 'goToProvider':
        providerAction({ provider: cta?.param, tags: tags, tagList: tagList });
        break;
      case 'goToExternalUrl':
        externalUrlAction(cta?.param);
        break;
      case 'goToGame':
        handleActionGame(cta?.param as number);
        break;
      case 'goToCategory':
        categoryAction(cta?.param);
        break;
      case 'goToRace':
      case 'noAction':
        break;
      default:
        return;
    }
  };

  const haveButtonAction = carouselItemData?.buttonAction?.variant !== 'noAction';
  const haveSlideClickAction = carouselItemData?.slideClickAction?.variant !== 'noAction';

  const clickActionProps = useMemo(
    () =>
      haveSlideClickAction
        ? {
            onClick: () => ctaAction(carouselItemData?.slideClickAction),
            style: {
              cursor: 'pointer',
              width: `${100 / (12 / cols)}vw`,
            },
          }
        : {
            style: {
              cursor: 'auto',
              width: `${100 / (12 / cols)}vw`,
            },
          },
    [
      haveSlideClickAction,
      user,
      kycStatus,
      totalActivityLimitValue,
      totalBetLimitValue,
      totalLossLimitValue,
      totalDepositValue,
    ]
  );

  useEffect(() => {
    categoriesData &&
      setTagList(categoriesData[selectedCategory]?.tags?.filter((f) => f.tagName === 'allGames')?.[0].tagGames || []);
  }, [categoriesData]);

  if (cols !== 12) {
    return (
      <div {...clickActionProps} className="small_bannerItem">
        <img
          src={carouselItemData?.image?.path}
          alt="Slider banner"
          style={{
            borderRadius: TEMPLATE_RADIUS[generalConfigs?.template || 'template_noFullScreen'],
          }}
        />
        <div className="small_banner_buttons_container">
          {haveButtonAction && (
            <Button
              className="success-filled-btn"
              onClick={(e) => {
                e.stopPropagation();
                ctaAction(carouselItemData?.buttonAction);
              }}
            >
              <SvgIcon src={icons.arrowDown} />
            </Button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div {...clickActionProps} className="bannerItem">
      <img
        src={carouselItemData?.image?.path}
        loading="lazy"
        alt="Slider banner"
        className="banner-img"
        style={{
          borderRadius: isMobileOnly ? 0 : TEMPLATE_BANNNER_RADIUS[generalConfigs?.template || 'template_noFullScreen'],
        }}
      />
      <div className={cn('banner_buttons_container', 'bottomLeft')}>
        {haveButtonAction && (
          <Button
            className="banner_inner_button primary-filled-btn"
            onClick={(e) => {
              e.stopPropagation();
              ctaAction(carouselItemData?.buttonAction);
            }}
          >
            {carouselItemData?.buttonAction?.label || t('goTo')}
          </Button>
        )}
      </div>
    </div>
  );
};
export default CarouselSlideItem;
